import { snapshot } from 'valtio';
import ApiKeysStore from '../stores/api-keys-store';
import { ApiKey } from '../types/api-key-types';

export const setLoadingApiKeys = (isLoading: boolean) => {
  ApiKeysStore.isLoading = isLoading;
};

export const clearErrorMessage = () => {
  ApiKeysStore.errorMessage = null;
};

export const setErrorMessage = (msg: string) => {
  ApiKeysStore.errorMessage = msg;
};

export const setApiKeys = (apiKeys: ApiKey[]) => {
  ApiKeysStore.apiKeys = apiKeys;
};

export const addApiKey = (apiKey: ApiKey) => {
  const { apiKeys } = snapshot(ApiKeysStore);

  ApiKeysStore.apiKeys = [...apiKeys, apiKey];
};

export const removeApiKey = (id: string) => {
  const { apiKeys } = snapshot(ApiKeysStore);

  ApiKeysStore.apiKeys = apiKeys.filter(a => a.id !== id);
};

export const updateApiKey = (apiKey: ApiKey) => {
  const { apiKeys } = snapshot(ApiKeysStore);

  ApiKeysStore.apiKeys = apiKeys.map(a => {
    return a.id === apiKey.id ? apiKey : a;
  });
};
